import { jsx as _jsx } from "react/jsx-runtime";
import { NotFoundPage as SharedNotFoundPage } from 'Shared/components/NotFoundPage';
export const NotFoundPage = () => (_jsx(SharedNotFoundPage, { showContactText: false }, void 0));
